define("calendar/components/calendar/notes-trial-start", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Portal @destinationElement="root-portal">
    <Shared::Modal @close={{@closeModal}} @focusTrap={{true}} as |modal|>
      <modal.card @portrait={{true}} class="cNO---modalCard cNO--modal--restrict">
  
        <modal.card-header>
          <h2 class="o--modalHeader__title u--text--light">
            {{svg-jar "notes" class="o--icon o--icon--light u--float--right"}}
            {{t "calendar_notes.notes" count=1}}
          </h2>
          <p class="u--text--sm u--text--light u--m__b__0">
            {{t "calendar_notes.visible_to_all_users"}}
          </p>
        </modal.card-header>
  
        <modal.card-body class="u--p__t__0 u--text--center cNO--modal--restrict__content">
          <h2 class="o--modalHeader__title u--m__t__xs">
            {{t "calendar_notes.want_to_leave"}}
          </h2>
          <p class="u--text--sm u--text--light u--m__b__0">
            {{this.bodySubText}}
          </p>
        </modal.card-body>
  
        <modal.card-footer class="cNO---modalFooter">
          <Shared::Button::Upgrade
            @additional="block"
            @feature="calendarNotes"
            @location="calendar page note"
            @seamlessCheckoutSuccessCallback={{@closeModal}}
            @text={{this.upgradeButtonText}}
            @variant="proceed"
            data-test-notes-trial-start="upgrade-button"
          />
        </modal.card-footer>
  
      </modal.card>
    </Shared::Modal>
  </Shared::Portal>
  */
  {
    "id": "NKx9sKqL",
    "block": "[[[8,[39,0],null,[[\"@destinationElement\"],[\"root-portal\"]],[[\"default\"],[[[[1,\"\\n  \"],[8,[39,1],null,[[\"@close\",\"@focusTrap\"],[[30,1],true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card\"]],[[24,0,\"cNO---modalCard cNO--modal--restrict\"]],[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n\\n      \"],[8,[30,2,[\"card-header\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[10,\"h2\"],[14,0,\"o--modalHeader__title u--text--light\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"notes\"],[[\"class\"],[\"o--icon o--icon--light u--float--right\"]]]],[1,\"\\n          \"],[1,[28,[35,3],[\"calendar_notes.notes\"],[[\"count\"],[1]]]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--text--sm u--text--light u--m__b__0\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"calendar_notes.visible_to_all_users\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n      \"],[8,[30,2,[\"card-body\"]],[[24,0,\"u--p__t__0 u--text--center cNO--modal--restrict__content\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[10,\"h2\"],[14,0,\"o--modalHeader__title u--m__t__xs\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"calendar_notes.want_to_leave\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--text--sm u--text--light u--m__b__0\"],[12],[1,\"\\n          \"],[1,[30,0,[\"bodySubText\"]]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n      \"],[8,[30,2,[\"card-footer\"]],[[24,0,\"cNO---modalFooter\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[8,[39,4],[[24,\"data-test-notes-trial-start\",\"upgrade-button\"]],[[\"@additional\",\"@feature\",\"@location\",\"@seamlessCheckoutSuccessCallback\",\"@text\",\"@variant\"],[\"block\",\"calendarNotes\",\"calendar page note\",[30,1],[30,0,[\"upgradeButtonText\"]],\"proceed\"]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n    \"]],[]]]]],[1,\"\\n  \"]],[2]]]]],[1,\"\\n\"]],[]]]]]],[\"@closeModal\",\"modal\"],false,[\"shared/portal\",\"shared/modal\",\"svg-jar\",\"t\",\"shared/button/upgrade\"]]",
    "moduleName": "calendar/components/calendar/notes-trial-start.hbs",
    "isStrictMode": false
  });
  let NotesTrialStartComponent = _exports.default = (_class = class NotesTrialStartComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor3, this);
    }
    get bodySubText() {
      if (this.subscriptions.isEligibleForTrial) {
        return this.intl.t('calendar_notes.start_trial', {
          planName: this.intl.t('plans.plan_names.growth')
        });
      }
      return this.intl.t('calendar_notes.upgrade_to_growth', {
        planName: this.intl.t('plans.plan_names.growth')
      });
    }
    get canCalendarNotes() {
      return Boolean(this.auth.currentAccount.canCalendarNotes);
    }
    get upgradeButtonText() {
      if (this.subscriptions.isEligibleForTrial) {
        return this.intl.t('authorization.sign_up_trial.button_yes');
      } else if (this.subscriptions.hasActiveTrial && !this.canCalendarNotes) {
        return this.intl.t('plans.upgrade.upgrade_trial');
      }
      return this.intl.t('shared_phrases.upgrade_plan');
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, NotesTrialStartComponent);
});